import { AreaOfInterestAPI } from "../APICommands/index.js";
import { ModelBase } from "./ModelBase.js";
import pointInPolygon from "point-in-polygon";
import { Zone } from "./Zone.js";
import { SensorReadingConfiguration } from "verdi-common/schemas/sensorReadingConfiguration/sensorReadingConfiguration";
import { VertexInfo } from "verdi-common/schemas/commonSubSchemas/vertexInfo";
import { AreaOfInterestSchemaTypes } from "../../../verdi-common/src/schemas/types/areaOfInterest.js";

export class AreaOfInterest extends ModelBase {
    checkForRecentData = true;
    /**
     * Every vertices in coordinates for mapping purposes
     * @type {{lat, lng}[]}
     */
    polygon = [];

    zonesInArea: Zone[] = [];
    sensorReadingConfiguration: SensorReadingConfiguration = {
        schemaKey: SensorReadingConfiguration.schemaKey,
        configurationBySensorType: {},
        customRules: [],
    };

    /**
     * Creates a new entity of this type and sends it to the server. When the server accepts the new entity, a new local entity
     * is created and this function returns.
     * @constructor
     */
    static async createNew(polygons: VertexInfo[][], name: string): Promise<AreaOfInterest> {
        const json = await AreaOfInterestAPI.createOne({ polygons, name });
        return new AreaOfInterest(json);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(json: any) {
        super(json);
        this.category = "aoi";
        this.dbID = json._id || json.id;
        this.name = json.name || json.label;
        this.owner = json.owner;
        this.sensorReadingConfiguration = json.sensorReadingConfiguration ?? this.sensorReadingConfiguration;
        if (json.polygons) {
            this.polygon = json.polygons[0];
        } else if (json.vertices) {
            this.polygon = json.vertices[0];
        }
        this.load().catch((e) => {
            console.warn(e);
        });
    }
    getJSON() {}

    /**
     * Deletes this entity and returns when the entity has been deleted from the server.
     */
    async delete(): Promise<void> {
        await AreaOfInterestAPI.deleteOne(this.id).then(() => {
            super.delete();
        });
    }

    /**
     *
     * @return {Promise<AreaOfInterest>}
     * @param newProperties
     */
    async edit(newProperties?: AreaOfInterestSchemaTypes["update"]): Promise<AreaOfInterest> {
        await AreaOfInterestAPI.editOne(this.id, newProperties).then((r) => {
            this._lastJSON = r;
            this.name = r.name;
            this.polygon = r.polygons[0];
            this.onChange.trigger({ target: this });
            this.sensorReadingConfiguration = r.sensorReadingConfiguration ?? this.sensorReadingConfiguration;
        });
        return this;
    }

    containsPoint(lat: number, lng: number) {
        const transformedBoundaries = this.polygon.map((p) => [p.lat, p.lng]);
        const point = [lat, lng];
        return pointInPolygon(point, transformedBoundaries);
    }
}
